import { Action } from '@ngrx/store'

import { FacetCount } from '../../facets/models/facet-count'
import { FacetGroup } from '../../facets/models/facet-group'
import { Facet } from '../../facets/models/facet'
import { AppliedFacets } from '../../facets/models/applied-facets';

export const INIT_GROUPS = '[Order] Init Groups'
export const INIT_GROUPS_SUCCESS = '[Order] Init Groups Success'
export const INIT_GROUPS_FAILED = '[Order] Init Groups Failed'

export const INIT_FACETS = '[Order] Init Facets'
export const INIT_FACETS_SUCCESS = '[Order] Init Facets Success'
export const INIT_FACETS_FAILED = '[Order] Init Facets Failed'

export const LOAD = '[Order] Facets Load'
export const LOAD_SUCCESS = '[Order] Facets Load Success'
export const LOAD_FAILED = '[Order] Facets Load Failed'

export const APPLY = '[Order] Facets Apply'

export class Load implements Action {
    readonly type = LOAD
    constructor() {}
}

export class LoadSuccess implements Action {
    readonly type = LOAD_SUCCESS
    constructor(public payload: FacetCount[]) {}
}

export class LoadFailed implements Action {
    readonly type = LOAD_FAILED
    constructor(public payload: any) {}
}

export class InitGroups implements Action {
    readonly type = INIT_GROUPS
}

export class InitGroupsSuccess implements Action {
    readonly type = INIT_GROUPS_SUCCESS
    constructor(public payload: FacetGroup[]) {}
}

export class InitGroupsFailed implements Action {
    readonly type = INIT_GROUPS_FAILED
    constructor(public payload: any) {}
}

export class InitFacets implements Action {
    readonly type = INIT_FACETS
}

export class InitFacetsSuccess implements Action {
    readonly type = INIT_FACETS_SUCCESS
    constructor(public payload: Facet[]) {}
}

export class InitFacetsFailed implements Action {
    readonly type = INIT_FACETS_FAILED
    constructor(public payload: any) {}
}

export class Apply implements Action {
    readonly type = APPLY
    constructor(public payload: AppliedFacets) {}
}

export type Actions = 
    Load
    | LoadSuccess
    | LoadFailed
    | InitGroups
    | InitGroupsSuccess
    | InitGroupsFailed
    | InitFacets
    | InitFacetsSuccess
    | InitFacetsFailed
    | Apply